import Vue from 'vue'
import Vuex from 'vuex'
import { DateTime } from 'luxon'

Vue.use(Vuex)

const state = {
  connected: false,
  name: '',
  photo: {
    data: '',
    source_index: 0,
    state: '',
    board: '',
    name: ''
  },
  chips: [],
  counters: {
    ok: 0,
    source: {
      current: 0,
      total: 0
    },
    rejects: []
  },
  start_chip: 0,
  start_time: DateTime.local(),
  boards: [],
  heartbeat: DateTime.fromISO('2000-01-01T00:00:01.000Z'),
  last_hash: '',
  results: {}
}

const getters = {
  secsSinceLastUpdate: state => {
    return Math.ceil( DateTime.local().diff(state.heartbeat) / 1000 )
  },
  stopped: state => {
    return Math.ceil( DateTime.local().diff(state.heartbeat) / 1000 ) > 600
  }
}

const actions = {
  new_message: ({ commit }, msg) => {
    console.log('New message!', msg)
  }
}

function receivedChip(state, cd) {
  console.log('New chip', cd)
  if(!cd.tests) {
    cd.tests = []
  }
  for ( var ic = 0; ic < state.chips.length; ic++ ) {
    if ( state.chips[ic].id === cd.id ) {
      state.chips.splice(ic,1)
      break
    }
  }
  state.chips.splice(0,0,cd)
  while (state.chips.length > 20) {
    state.chips.splice(state.chips.length - 1,1)
  }
}

function receivedStats(state, stats) {
  console.log('Stats update', stats)
  state.name = stats.name
  state.counters.ok = stats.state.next_ok
  state.counters.source.current = stats.state.next_source
  state.counters.source.total = stats.loaded.sources
  state.start_chip = stats.start_chip
  state.start_time = DateTime.fromISO( stats.start_time )
  while( state.counters.rejects.length < stats.state.next_reject.length ) {
    state.counters.rejects.splice(0,0,{current: 0, total: 0, id: ''})
  }
  for( var ir = 0; ir < stats.state.next_reject.length; ir++ ){
    state.counters.rejects[ir].current = stats.state.next_reject[ir]
    state.counters.rejects[ir].total = stats.loaded.rejects[ir].total
    state.counters.rejects[ir].id = stats.loaded.rejects[ir].id || 'any'
  }
  for( ir = 0; ir < stats.state.boards.length; ir++ ){
    if( state.boards.length <= ir ) {
      state.boards.splice(ir,0,stats.state.boards[ir])
    } else {
      state.boards.splice(ir,1,stats.state.boards[ir])
    }
    state.boards[ir].id = stats.loaded.sockets[ir].id
  }
}

function receivedPhoto(state, photo) {
  state.photo.data = photo.data
  state.photo.source_index = photo.source_index
  state.photo.state = photo.state
  state.photo.board = photo.board
  state.photo.name = photo.name
}

function receivedResults(state,data) {
  console.log('Stats results', data)
  state.results = data
}

const mutations = {
  SOCKET_ONERROR (state, event) {
    console.log('EROR', state, event)
  },
  SOCKET_ONMESSAGE (state, msg) {
    var d = JSON.parse(msg.data)
    if (d.type === 'photo') {
      receivedPhoto(state,d.data)
      return
    }
    if (d.type === 'chip') {
      receivedChip(state,d.data)
      return
    }
    if (d.type === 'results') {
      receivedResults(state,d.data)
      return
    }
    if( state.last_hash !== d.hash ){
      receivedStats(state, d.data)
      state.last_hash = d.hash
      state.heartbeat = DateTime.fromISO(d.date)
    }
    // Change title
    document.title = `Roboweb (${state.name} ${state.counters.source.current}/${state.counters.source.total})`
  },
  SOCKET_ONOPEN(state,msg) {
    state.connected = true
  },
  SOCKET_ONCLOSE(state,msg) {
    state.connected = false
  }
}

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js